import * as React from 'react';
import { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import i18n from '@/utils/i18n';
import { costToPrice } from '@/utils/formatter';
import { Communicator } from '../../tools/Communication';
import { FaEdit } from 'react-icons/fa';
import { Button, Table } from 'reactstrap';
import { Routes } from '@/utils/routes';

type UserBillingTabProps = {
  userId: string | undefined;
};

export interface Cost {
  amount: number;
  currencyId: number;
  amountInCents: number;
}

export interface Bill {
  cost: Cost;
  creationTimestamp: Date;
  id: string;
  paymentState: number;
  userId: string;
}

export default function UserBillingTab(props: UserBillingTabProps) {
  const [deadlineExtensionBills, setDeadlineExtensionBills] = useState<Bill[]>(
    [],
  );
  const [overduePenaltyBills, setOverduePenaltyBills] = useState<Bill[]>([]);

  const { userId } = props;

  useEffect(() => {
    (async () => {
      const response = await Communicator.Get('/Billing/GetBillsOfUsers', {
        userId: encodeURIComponent(userId || ''),
      });
      const data = await response.json();
      setOverduePenaltyBills(data.overduePenaltyBills);
      setDeadlineExtensionBills(data.deadlineExtensinoBills);
    })();
  }, [userId]);

  return (
    <div>
      <br />
      <h4>{i18n.t('Billing:overduePenaltyBills')}</h4>
      <BillTable bills={overduePenaltyBills} billType="Penalty" />

      <br />

      <h4>{i18n.t('Billing:deadlineExtensionBills')}</h4>
      <BillTable bills={deadlineExtensionBills} billType="DeadlineExtension" />
    </div>
  );
}

type BillTableProps = {
  bills: Bill[];
  billType: string;
};

function BillTable(props: BillTableProps) {
  const { bills, billType } = props;

  const history = useHistory();

  return (
    <Table className="table-striped table" responsive>
      <thead>
        <tr>
          <th className="numbers-formatted">{i18n.t('Common:amount')}</th>
          <th>{i18n.t('Billing:creationTimestamp')}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {bills.map((bill) => (
          <tr
            key={bill.id}
            onClick={() =>
              history.push(Routes.bill(billType, encodeURIComponent(bill.id)))
            }
          >
            <td className="numbers-formatted">{costToPrice(bill.cost)}</td>
            <td>{bill.creationTimestamp.toDateString()}</td>
            <td>
              <Link to={Routes.bill(billType, encodeURIComponent(bill.id))}>
                <Button>
                  <FaEdit />
                </Button>
              </Link>
            </td>
          </tr>
        ))}
        {bills.length === 0 && (
          <tr>
            <td colSpan={3}>{i18n.t('Billing:noBillsFound')}</td>
          </tr>
        )}
      </tbody>
    </Table>
  );
}
